var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowEggRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00004 16.0002C8.00004 20.1303 10.8855 22.6668 13.5 22.6668C15.2192 22.6668 18.4822 21.7747 21.3657 20.0893C22.7605 19.274 23.8453 18.3978 24.5374 17.5758C25.2317 16.7512 25.3334 16.2293 25.3334 16.0002C25.3334 15.7711 25.2317 15.2492 24.5374 14.4245C23.8453 13.6026 22.7605 12.7263 21.3657 11.9111C18.4822 10.2257 15.2192 9.3335 13.5 9.3335C10.8855 9.3335 8.00004 11.8701 8.00004 16.0002ZM4.00004 16.0002C4.00004 21.8912 8.25333 26.6668 13.5 26.6668C18.7467 26.6668 29.3334 21.8912 29.3334 16.0002C29.3334 10.1091 18.7467 5.3335 13.5 5.3335C8.25333 5.3335 4.00004 10.1091 4.00004 16.0002Z",
    fill: "#3360AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowEggRight);
export default __webpack_public_path__ + "static/media/arrow-egg-right.c45e30f2c1fff07f4ab9e705bd914ec4.svg";
export { ForwardRef as ReactComponent };